// رموز أدوات شريط التنقّل — رسمٌ متّجه بجانب كل اسم في قائمة «أدوات هامة» و«إعدادات».
//
// لماذا رسمٌ لا رمزٌ تعبيري (emoji): الرموز التعبيرية تختلف من نظامٍ لآخر وقد لا تُرسم
// أصلًا على ويندوز (كما حدث مع أعلام الدول في «توقيت المدن»)، وحجمها لا يُضبط بالخطّ.
// والرسم هنا `currentColor` فيأخذ لون العنصر — أبيض حين يكون مفتوحًا، وأخضر حين لا.
//
// وكلّها بخطٍّ لا بمساحات مصمتة: أهدأ للعين بجانب النصّ، ولا تسحب الانتباه من الاسم.
import type { ReactNode } from 'react';

const S = {
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.7, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  className: 'h-[1.15rem] w-[1.15rem] shrink-0',
  'aria-hidden': true,
};

/** حاسبة سعر البيع */
const Calculator = () => (
  <svg {...S}><rect x="4" y="3" width="16" height="18" rx="2.5" /><path d="M8 7h8" />
    <path d="M8.5 12h.01M12 12h.01M15.5 12h.01M8.5 16h.01M12 16h.01M15.5 16h.01" /></svg>
);

/** رسوم التقسيط — بطاقة على مكنة الدفع */
const CardTerminal = () => (
  <svg {...S}><rect x="3" y="6" width="18" height="12" rx="2.5" /><path d="M3 10h18" />
    <path d="M7 14.5h3" /></svg>
);

/** توقيت المدن */
const Clock = () => (
  <svg {...S}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 1.8" /></svg>
);

/** محوّل العملات */
const Exchange = () => (
  <svg {...S}><path d="M4 8h13l-3-3M20 16H7l3 3" /></svg>
);

/** حجز فندق مبدئي */
const Hotel = () => (
  <svg {...S}><path d="M4 20V5.5A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5V20" />
    <path d="M16 11h2.5A1.5 1.5 0 0 1 20 12.5V20M2.5 20h19" />
    <path d="M7.5 8h1.5M11.5 8H13M7.5 11.5h1.5M11.5 11.5H13" /><path d="M9 20v-4h2.5v4" /></svg>
);

/** عرض سعر — ورقة ببنودٍ وسعر */
const Quote = () => (
  <svg {...S}><path d="M6 3.5h8.5L19 8v12.5H6z" /><path d="M14 3.5V8h5" />
    <path d="M9 12.5h6M9 16h4" /></svg>
);

/** بيانات الحساب */
const User = () => (
  <svg {...S}><circle cx="12" cy="8.5" r="3.5" /><path d="M5 19.5c1.2-3.2 4-4.8 7-4.8s5.8 1.6 7 4.8" /></svg>
);

/** سجل التدقيق */
const Ledger = () => (
  <svg {...S}><path d="M6 3.5h11A1.5 1.5 0 0 1 18.5 5v14A1.5 1.5 0 0 1 17 20.5H6" />
    <path d="M6 3.5A1.5 1.5 0 0 0 4.5 5v14A1.5 1.5 0 0 0 6 20.5" /><path d="M8.5 8h7M8.5 12h7M8.5 16h4" /></svg>
);

/** النسخ الاحتياطي */
const Backup = () => (
  <svg {...S}><ellipse cx="12" cy="6.5" rx="7" ry="2.8" />
    <path d="M5 6.5v11c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8v-11" /><path d="M5 12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8" /></svg>
);

/** الرمز بحسب التبويب — وما لا رمز له لا يُرسم له شيء. */
/** كلمة مرور الحساب — مفتاح */
const Key = () => (
  <svg {...S}><circle cx="8" cy="14" r="4" /><path d="M11 11 20 2" /><path d="M16 6l2.5 2.5M13.5 8.5 16 11" /></svg>
);

/** كلمة مرور الخزنة — قفل */
const Lock = () => (
  <svg {...S}><rect x="5" y="11" width="14" height="10" rx="2.5" /><path d="M8 11V8a4 4 0 0 1 8 0v3" />
    <path d="M12 15.5v2" /></svg>
);

/** تفقيط المبالغ — ورقة عليها «أ ب» */
const Letters = () => (
  <svg {...S}><path d="M7 3.5h7l4 4V20.5H7z" /><path d="M14 3.5v4h4" />
    <path d="M9.5 16.5l1.6-4.5 1.6 4.5M10 15.3h2.2" /><path d="M14.5 12h1.6a1.2 1.2 0 0 1 0 2.4h-1.6zM14.5 14.4h1.9a1.2 1.2 0 0 1 0 2.4h-1.9z" /></svg>
);

/** ميلادي ↔ هجري — تقويم بهلال */
const HijriCalendar = () => (
  <svg {...S}><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" /><path d="M3.5 9.5h17M8 3v4M16 3v4" />
    <path d="M14.2 13.2a2.6 2.6 0 1 0 0 4.6 3 3 0 0 1 0-4.6z" /></svg>
);

/** أكواد المطارات — طائرة */
const Plane = () => (
  <svg {...S}><path d="M10.5 20.5 12 17l-1.5-4.5L4 10V8l7 1.5V5a1 1 0 0 1 2 0v4.5L20 8v2l-6.5 2.5L12 17l1.5 3.5" /></svg>
);

export function toolIcon(id: string): ReactNode {
  switch (id) {
    case 'quote': return <Quote />;
    case 'pricing': return <Calculator />;
    case 'installment': return <CardTerminal />;
    case 'tafqeet': return <Letters />;
    case 'hijri': return <HijriCalendar />;
    case 'clock': return <Clock />;
    case 'airports': return <Plane />;
    case 'fx': return <Exchange />;
    case 'hotel-voucher': return <Hotel />;
    case 'account': return <User />;
    case 'account-password': return <Key />;
    case 'account-lock': return <Lock />;
    case 'admin-audit': return <Ledger />;
    case 'admin-backups': return <Backup />;
    default: return null;
  }
}
